import React from "react";

export default function WeatherIcon(props) {
  return (
    <img
      src={props.icon_url}
      alt="weatherIcon"
      width={props.size}
      height={props.size}
    ></img>
  );
}
